import { useTheme } from "@mui/material/styles";
import type { FC } from "react";
import { ASSISTANT_AVATAR } from "@/theme/tokens";
import { pxToArtUnits, starPath } from "@/ui/AssistantAvatar/assistantAvatarGeometry";

const { AI_MARKER } = ASSISTANT_AVATAR;
const CENTER = 100;
const DRAWN_RADIUS = 11;
const GLYPH_TO_DISC = 6 / 11;
const RING_WIDTH = 3;

/** The "this is AI" disc on every human avatar, so a stylized face never passes for a real person. */
export const HumanAiMarker: FC<{ size: number }> = ({ size }) => {
	const theme = useTheme();
	const radius = Math.max(DRAWN_RADIUS, pxToArtUnits(AI_MARKER.MIN_DIAMETER_PX / 2, size));
	return (
		<g>
			<circle cx={CENTER} cy={CENTER} r={radius} fill={theme.palette.primary.main} stroke={AI_MARKER.RING} strokeWidth={RING_WIDTH} />
			<path d={starPath(CENTER, CENTER, radius * GLYPH_TO_DISC)} fill={theme.palette.primary.contrastText} />
		</g>
	);
};
